<template>
  <div
    :id="id"
    class="chart"
  ></div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },

    data: {
      type: Array,
      default: () => {
        return []
      }
    },

    color: {
      type: String,
      default: '#4462d4'
    },

    rotate: {
      type: Boolean,
      default: true
    }
  },

  mounted() {
    this.$nextTick(async() => {
      this.makeChart()
    })
  },

  methods: {
    baseSettings() {
      return {
        colors: ['#4EB49D', '#4E71B8', '#F1963D', '#EF6448', '#A166AB'],
        hideCredits: true,
        zoomOutText: '',
        startDuration: 0,
        pullOutRadius: 0,
        backgroundColor: '#fff',
        backgroundAlpha: '1',
        color: '#3C4B64',
        fontFamily: 'Helvetica Neue',
        fontSize: 11,

        // Subtitles
        legend: {
          enabled: true,
          useGraphSettings: true,
          switchable: false,
          valueText: '',
          equalWidths: false
        },

        // Responsive settings
        responsive: {
          enabled: true,
          rules: [
            // at 400px wide, we hide legend
            {
              maxWidth: 520,
              overrides: {
                rotate: true
              }
            }]
        },
        zoomControl: {
          maxZoomLevel: 4
        },
        mouseWheelZoomEnabled: true,
        chartCursor: {
          pan: true,
          valueLineEnabled: false,
          valueLineBalloonEnabled: false,
          categoryBalloonEnabled: false,
          cursorAlpha: 0,
          cursorColor: '',
          valueLineAlpha: 0,
          valueZoomable: false
        },
        chartScrollBar: {
          updateOnReleaseOnly: true
        },

        // Export
        export: {
          enabled: true,
          menu: [
            {
              format: 'PNG',
              class: 'export-main',
              multiplier: 2,
              label: 'Salvar como PNG',
              title: 'Exportar gráfico como PNG'
            }
          ]
        },
        thousandsSeparator: '.'
      }
    },

    makeChart() {
      const baseSettings = this.baseSettings()

      window.AmCharts.makeChart(this.id,
        {
          // Base settings
          ...baseSettings,
          type: 'serial',
          rotate: this.rotate,

          // X axis settings
          categoryField: 'id',
          categoryAxis: {
            gridAlpha: 0,
            axisAlpha: 0,
            startOnAxis: false,
            offset: 0,
            gridAboveGraphs: true
          },

          // Graph settings
          graphs: [
            {
              balloonText: '<b>[[title]]</b>: [[views]] acessos',
              id: 'AmGraph-1',
              title: 'Acessos',
              valueField: 'views',
              lineAlpha: 0,
              fillAlphas: 1,
              fillColors: this.color,
              columnWidth: this.rotate ? 0.6 : 0.3,
              type: 'column'
            }
          ],

          // Y axis settings
          valueAxes: [
            {
              gridColor: '#ebedef',
              gridAlpha: 0.7,
              dashLength: 0,
              integersOnly: true,
              gridPosition: 'start',
              strictMinMax: true,
              axisAlpha: 1,
              axisColor: '#ebedef',
              axisThickness: 1,
              offset: '0',
              baseValue: '-1',
              position: 'left',
              ignoreAxisWidth: false
            }
          ],

          // Chart data
          dataProvider: this.data
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
  .chart {
    width: 100%;
    height: 350px;
    position: relative;
  }

  @media only screen and (max-width: 992px) {
    .chart {
      width: 100%;
      height: 250px;
    }
  }
</style>
